module.exports = __webpack_public_path__ + "img/project5.ba55fd62.jpg";